import React from "react";
import { useGlobal } from "reactn";
import ButtonSuccess from "components/Buttons/ButtonSuccess";
import { getUrl } from "@outplayed/riot-assets";
import { directToPage } from "lib/redirect-helpers";
import { useHistory } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { useLoginState } from "lib/hooks/userHooks";
import { GET_USER_STATE } from "api/graphql/queries";

const Profile200kSplash = (props) => {
  const history = useHistory();
  const [authToken] = useGlobal("authToken");
  const [loggingIn] = useGlobal("loggingIn");
  const isLoggedIn = useLoginState();
  const directToSignup = directToPage("signup");
  const directToVerification = directToPage("verification");

  const { loading: loadingUserState, data: userState, error: errorUserState } = useQuery(GET_USER_STATE, { skip: !authToken });

  const { lolSettings, premium } = (userState && userState.getState) || {};
  const { summoners } = lolSettings || {};
  const { summonerName, regionId, verified } = (summoners && summoners[0]) || {};
  const { isPremium } = premium || {};

  let splashState = "";
  if (!loggingIn && !isLoggedIn) {
    splashState = "logged-out";
  } else if (isPremium) {
    splashState = verified ? "verified" : "unverified";
  } else {
    // non BOOST user
    splashState = "free-user";
  }

  const buttonText = {
    // "logged-out": "Create Account",
    "logged-out": "Try Today",
    unverified: "Verify Account",
    verified: "My Profile",
    "free-user": "Try Today",
  };

  const buttonCallbacks = {
    "logged-out": () =>
      history.push({
        pathname: "/signup",
        search: "continue=/purchase/1-months&type=premium_boost",
      }),
    unverified: directToVerification,
    verified: () =>
      history.push({
        pathname: `/lol/profile/${regionId}/${summonerName.toLowerCase()}/overview`,
      }),
    "free-user": () =>
      history.push({
        pathname: "/boost/payment",
        search: "planType=1-months",
      }),
  };

  return (
    <div className="profile200kSplash">
      <div className="top-section">
        <div className="header">
          PROFILES WITH <span className="yellow-text">MORE YOU</span>
        </div>
        <div className="description">
          Our profiles are more personal than ever.{" "}
          {splashState === "free-user" || splashState === "logged-out"
            ? "Sign up for BOOST to customize yours today."
            : "Create an account to customize yours today."}
        </div>
        <ButtonSuccess
          className="login-submit btn-light-blue create-account-button"
          label={buttonText[splashState]}
          onClick={buttonCallbacks[splashState]}
        />
      </div>
      <div className="text-section">
        <div className="section-box">
          <div className="section-header">Autoload Your Profile</div>
          <div className="section-description">Save time. Set your profile as your home page. Never search yourself again.</div>
        </div>
        <div className="section-box">
          <div className="section-header">Socials</div>
          <div className="section-description">Promote your Twitch, Youtube, and Twitter for everyone to see.</div>
        </div>
        <div className="section-box">
          <div className="section-header">Custom Background</div>
          <div className="section-description">Your favorite is there - we've got every skin for every champion.</div>
        </div>
        <div className="section-box">
          <div className="section-header">Pinned Match</div>
          <div className="section-description">Show off your most memorable match by pinning it to the top of your profile.</div>
        </div>
      </div>
      <div style={{ position: "absolute" }}>
        <div className={"bottom-section " + splashState}>
          <img className="bottom-img" src={getUrl("lol/art/200kSplashImg2.png")} />
        </div>
      </div>
    </div>
  );
};

export default Profile200kSplash;
